import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import useCartStore, { CartIntent } from './cart'

const useShippingMethodStore = defineStore('shipping-method', () => {
  const cartStore = useCartStore()

  const providers = ref<ShippingProvider[]>([])
  const loading = ref(false)
  const selectedProviderService = ref<{ provider: string; service: string } | null>(null)
  const showShippingMethodDrawer = ref(false)

  const canSelectMethod = computed(() => {
    return selectedProviderService.value !== null && loading.value !== true
  })

  const selectShippingMethod = () => {
    if (!selectedProviderService.value) {
      return
    }

    const { provider, service } = selectedProviderService.value

    cartStore.cart.shipping_provider = provider
    cartStore.cart.shipping_service = service
    cartStore.intent = CartIntent.Synchronize
  }

  return {
    providers,
    loading,
    selectedProviderService,
    showShippingMethodDrawer,
    canSelectMethod,
    selectShippingMethod
  }
})

export default useShippingMethodStore
